import { SOCKET_IO_BASE_URL } from '@/constants/Environments'
window.io = require('socket.io-client')

export default class SocketIO {
  static connect () {
    return window.io.io(SOCKET_IO_BASE_URL)
  }
}
